import Vue from 'vue'
import Vuex from 'vuex'
import { post, get, put, destroy, API_ENDPOINT } from '@/helpers/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: {
      drawerTitle: 'Nadzorni Center',
      title: 'Nadzorni Center - KPSS',
      shortTitle: 'NC - KPSS',
      icon: 'language',
      appKey: 'app_kpss'
    },

    user: {
      id: null,
      name: null,
      email: null,
      role: null,
      permissions: null,
      access_token: null,
      last_seen: null
    },

    drawer: null,
    loader: false,
    progress: false,
    loaderText: '',
    toolbarTitle: '',
    search: '',

    snackbar: {
        display: false,
        y: 'bottom',
        x: 'left',
        mode: '',
        timeout: 6000,
        text: 'Hello, I\'m a snackbar'
    },

    access_log: [],
    currentRoute: null
  },

  mutations: {
    SET_USER(state, data) {
      if(data == null)
      {
          state.user.id = null
          state.user.name = null
          state.user.email = null
          state.user.role = null
          state.user.last_seen = null
          state.user.access_token = ""
      }
      else
      {
          state.user.id = data.id
          state.user.name = data.name
          state.user.email = data.email
          state.user.role = data.role
          state.user.last_seen = data.last_seen
          state.user.access_token = data.access_token
      }

      localStorage.setItem('app_kpss', JSON.stringify(state.user))
    },

    SET_DRAWER (state, value) {
      state.drawer = value
    },

    SET_TOOLBAR_TITLE (state, title) {
        state.toolbarTitle = title
    },

    SET_LOADER (state, value) {
        state.loader = value
    },

    SET_LOADER_TEXT (state, text) {
        state.loaderText = text
    },

    SET_SEARCH (state, search) {
        state.search = search
    },

    SET_PROGRESS (state, value) {
        state.progress = value
    },

    SET_CURRENT_ROUTE (state, routeName) {
        state.currentRoute = routeName
    },

    SET_SNACKBAR_TEXT (state, text) {
        state.snackbar.text = text
    },

    SET_SNACKBAR_DISPLAY (state, display) {
        state.snackbar.display = display
    },
    
    SET_SNACKBAR_Y (state, y) {
        state.snackbar.y = y
    },

    SET_SNACKBAR_X (state, x) {
        state.snackbar.x = x
    },

    SET_SNACKBAR_MODE (state, mode) {
        state.snackbar.mode = mode
    },

    SET_SNACKBAR_TIMEOUT (state, timeout) {
        state.snackbar.timeout = timeout
    },

    setSearch (state, search) {
      state.search = search
  },

    snackbarDisplay (state, display) {
        state.snackbar.display = display
    },

    snackbarY (state, y) {
        state.snackbar.y = y
    },

    snackbarX (state, x) {
        state.snackbar.x = x
    },

    snackbarMode (state, mode) {
        state.snackbar.mode = mode
    },

    snackbarTimeout (state, timeout) {
        state.snackbar.timeout = timeout
    },

    snackbarText (state, text) {
        state.snackbar.text = text
    }
  },

  actions: {
    ROUTE_NAME (context, routeName) {
        context.commit('SET_CURRENT_ROUTE', routeName)
    },

    LOGIN (context, credentials) {
      return new Promise( (resolve, reject) => {
          post(API_ENDPOINT + 'auth/user-login', credentials) 
              .then(response => {
                  context.commit('SET_USER', response.data)
                  resolve(response)
              })
              .catch(error => {
                  reject(error)
              })
      })
    },

    LOGOUT (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'auth/logout')
            .then(response => {
                context.commit('SET_USER', null)
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PASSWORD_RESET_REQUEST (context, email) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'password/create', email)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PASSWORD_RESET (context, credentials) {
        return new Promise( (resolve, reject) => {
            post(API_ENDPOINT + 'password/reset', credentials)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    RESTRICTION_TYPES (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'kpss/restriction-types')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    CONVERT_RFID_NR (context, data) {
        return new Promise ((resolve, reject) => {
            post(API_ENDPOINT + 'utilities/rfid-nr', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    RFID_NR_SEARCH (context, nr) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'utilities/rfid-nr/' + nr)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    
    CREATE_RFID_USER (context, data) {
        return new Promise ((resolve, reject) => {
            post(API_ENDPOINT + 'kpss/rfid-users/create', data )
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    GET_RFID_USER (context, userId) {
        return new Promise((resolve, reject) => {
            get(API_ENDPOINT + 'kpss/rfid-users/' + userId)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    UPDATE_RFID_USER(context, data) {
        return new Promise((resolve, reject) => {
            post(API_ENDPOINT + 'kpss/rfid-users/' + data.id + '/update', data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    DELETE_RFID_USER (context, id) {
        return new Promise((resolve, reject) => {
            destroy(API_ENDPOINT + 'kpss/rfid-users/' + id + '/delete')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    PARAMETERS_DATA (context) {
        return new Promise( (resolve, reject) => {
            get(API_ENDPOINT + 'kpss/parameters-data')
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
  },

  getters: {
    user (state) {
      return state.user
    },

    loader (state) {
        return state.loader
    },

    progress (state) {
        return state.progress
    },

    loaderText (state) {
        return state.loaderText
    },

    drawer (state) {
        return state.drawer
    },

    toolbarTitle (state) {
        return state.toolbarTitle
    },

    snackbar (state) {
        return state.snackbar
    },

    search (state) {
        return state.search
    },

    app (state) {
        return state.app
    },

    access_log (state) {
        return state.access_log
    },

    currentRouteName (state) {
        return state.currentRoute
    }
  }
})
